import laboratoryProfileImage from "../../../assets/images/icons/laboratory-default.svg";
import radiologyProfileImage from "../../../assets/images/icons/radiology-default.svg";
import doctorProfileImage from "../../../assets/images/icons/doctor-default.svg";
import dentistProfileImage from "../../../assets/images/icons/dentist-default.svg";

export const getFacilityDefaultImage: (facilityCode: string) => string = (
  facilityCode: string,
) => {
  return facilityCode == "MEDIACLlABRATORY"
    ? laboratoryProfileImage
    : facilityCode == "RADIOLOGYCENTER"
      ? radiologyProfileImage
      : facilityCode == "DENTALCLINIC"
        ? dentistProfileImage
        : doctorProfileImage;
};
